export const GET_PROMOTIONS = 'promotions/allPromotions/get';
export const GET_ACTIVE_PROMOTIONS = 'promotions/activePromotions/get';
export const GET_PROMOTION_BY_SLUG = 'promotions/promotion/get/slug'
export const GET_PROMOTION_BY_ID = 'promotions/promotion/get/id'